import { MediaGallery, Label } from '@/fo/util/map-product-data';

export const tagsMock: Label[] = [
  {
    name: 'New'
  },
  {
    name: '-20%',
    color: 'yellow'
  }
];

export const imagesMock: MediaGallery = [
  {
    id: '1',
    type: 'image',
    src: 'https://dummyimage.com/400x400/003A70/FFFFFF?text=Capybara+1',
    alt: 'capybara',
    roles: []
  },
  {
    id: '2',
    type: 'image',
    src: 'https://dummyimage.com/400x400/003A70/FFFFFF?text=Capybara+2',
    alt: 'capybara',
    roles: []
  },
  {
    id: '3',
    type: 'image',
    src: 'https://dummyimage.com/400x400/003A70/FFFFFF?text=Capybara+3',
    alt: 'capybara',
    roles: []
  },
  {
    id: '4',
    type: 'image',
    src: 'https://dummyimage.com/400x400/003A70/FFFFFF?text=Capybara+4',
    alt: 'capybara',
    roles: []
  },
  {
    id: '5',
    type: 'image',
    src: 'https://dummyimage.com/400x400/003A70/FFFFFF?text=Capybara+5',
    alt: 'capybara',
    roles: []
  },
  {
    id: '6',
    type: 'image',
    src: 'https://dummyimage.com/400x400/003A70/FFFFFF?text=Capybara+6',
    alt: 'capybara',
    roles: []
  },
  {
    id: '7',
    type: 'image',
    src: 'https://dummyimage.com/400x400/003A70/FFFFFF?text=Capybara+7',
    alt: 'capybara',
    roles: []
  },
  {
    id: '8',
    type: 'image',
    src: 'https://dummyimage.com/400x400/003A70/FFFFFF?text=Capybara+8',
    alt: 'capybara',
    roles: []
  }
];
